import { useState } from "react";
import { F, D } from "../../../styles/palette";
import { DC, Bdg } from "../../shared";
import useClinicalRecords from "../../../hooks/useClinicalRecords";
import { ISL } from "../../../data/islStages";
import EvolucionForm from "./EvolucionForm";

export default function Evoluciones({ patientId, user, patient }) {
  const { records, loading, addRecord } = useClinicalRecords(patientId);
  const [view, setView] = useState("list");
  const [expanded, setExpanded] = useState(null);

  if (view === "new") {
    return <EvolucionForm
      user={user}
      patient={patient}
      addRecord={addRecord}
      onCancel={() => setView("list")}
      onSaved={() => setView("list")}
    />;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
        <button onClick={() => setView("new")}
          style={{ padding: "9px 18px", borderRadius: 8, border: "none", background: D.ac, color: "#020617", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: F.b }}>
          + Nueva Evoluci\u00f3n
        </button>
      </div>

      {loading && <p style={{ color: D.txM, fontSize: 13, textAlign: "center" }}>Cargando evoluciones...</p>}

      {!loading && records.length === 0 && (
        <DC>
          <p style={{ color: D.txM, fontSize: 13, textAlign: "center", padding: 20 }}>
            No hay evoluciones registradas. Haga clic en "Nueva Evoluci\u00f3n" para crear la primera.
          </p>
        </DC>
      )}

      {records.map(r => {
        const isExp = expanded === r.id;
        const islData = r.objetivo?.estadioISL != null ? ISL[r.objetivo.estadioISL] : null;
        const fecha = r.fecha?.toDate ? r.fecha.toDate().toLocaleDateString("es-CO") : r.fecha || "";
        return (
          <div key={r.id}
            onClick={() => setExpanded(isExp ? null : r.id)}
            style={{ background: D.card, border: `1px solid ${isExp ? "rgba(45,212,191,0.3)" : D.bdr}`, borderRadius: 12, padding: "14px 18px", marginBottom: 8, cursor: "pointer", backdropFilter: "blur(12px)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <span style={{ color: D.ac, fontSize: 13, fontWeight: 800, fontFamily: F.m, marginRight: 8 }}>#{r.consecutivo}</span>
                <span style={{ color: "#e2e8f0", fontSize: 13, fontWeight: 600 }}>{fecha}</span>
                <span style={{ color: D.txM, fontSize: 12, marginLeft: 10 }}>{r.doctorNombre}</span>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                {islData && <Bdg t={islData.s} c={islData.c} />}
              </div>
            </div>
            {r.subjetivo?.motivo && (
              <p style={{ color: "#94a3b8", fontSize: 12, margin: "6px 0 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: isExp ? "normal" : "nowrap" }}>
                {isExp ? r.subjetivo.motivo : r.subjetivo.motivo.slice(0, 100) + (r.subjetivo.motivo.length > 100 ? "..." : "")}
              </p>
            )}

            {isExp && (
              <div style={{ marginTop: 14, borderTop: `1px solid ${D.bdr}`, paddingTop: 14 }}>
                {/* SOAP display */}
                {r.subjetivo?.motivo && (
                  <div style={{ marginBottom: 12 }}>
                    <h4 style={{ color: "#38bdf8", fontSize: 12, margin: "0 0 4px", fontFamily: F.b }}>S - Subjetivo</h4>
                    <p style={{ color: "#cbd5e1", fontSize: 12, margin: 0, whiteSpace: "pre-wrap" }}>{r.subjetivo.motivo}</p>
                  </div>
                )}
                {r.objetivo && (
                  <div style={{ marginBottom: 12 }}>
                    <h4 style={{ color: "#4ade80", fontSize: 12, margin: "0 0 4px", fontFamily: F.b }}>O - Objetivo</h4>
                    {r.objetivo.examenFisico && <p style={{ color: "#cbd5e1", fontSize: 12, margin: "0 0 4px", whiteSpace: "pre-wrap" }}>{r.objetivo.examenFisico}</p>}
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4 }}>
                      {r.objetivo.stemmer && <Bdg t="Stemmer +" c="#ea580c" />}
                      {r.objetivo.fovea && <Bdg t="F\u00f3vea +" c="#ca8a04" />}
                      {r.objetivo.vasDolor != null && <Bdg t={`VAS ${r.objetivo.vasDolor}/10`} c={r.objetivo.vasDolor <= 3 ? "#16a34a" : r.objetivo.vasDolor <= 6 ? "#ca8a04" : "#dc2626"} />}
                    </div>
                    {r.objetivo.volResultados && (
                      <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                        <Bdg t={`Af: ${r.objetivo.volResultados.affIdx}`} c="#dc2626" />
                        <Bdg t={`Sano: ${r.objetivo.volResultados.conIdx}`} c="#16a34a" />
                        <Bdg t={`Dif: ${r.objetivo.volResultados.diffPct}%`} c={Math.abs(r.objetivo.volResultados.diffPct) >= 20 ? "#dc2626" : "#ca8a04"} />
                      </div>
                    )}
                  </div>
                )}
                {r.analisis && (
                  <div style={{ marginBottom: 12 }}>
                    <h4 style={{ color: "#a78bfa", fontSize: 12, margin: "0 0 4px", fontFamily: F.b }}>A - An\u00e1lisis</h4>
                    <p style={{ color: "#cbd5e1", fontSize: 12, margin: 0, whiteSpace: "pre-wrap" }}>{r.analisis}</p>
                  </div>
                )}
                {r.plan && (
                  <div style={{ marginBottom: 12 }}>
                    <h4 style={{ color: "#fb923c", fontSize: 12, margin: "0 0 4px", fontFamily: F.b }}>P - Plan</h4>
                    <p style={{ color: "#cbd5e1", fontSize: 12, margin: 0, whiteSpace: "pre-wrap" }}>{r.plan}</p>
                  </div>
                )}
                {r.firmaDigital && (
                  <div style={{ marginTop: 10, padding: 10, background: "rgba(30,41,59,0.5)", borderRadius: 8, borderLeft: "3px solid #64748b" }}>
                    <div style={{ fontSize: 10, color: "#64748b" }}>Firma digital</div>
                    <div style={{ fontSize: 11, color: "#94a3b8" }}>{r.firmaDigital.doctorNombre} {r.firmaDigital.registroMedico ? `- RM: ${r.firmaDigital.registroMedico}` : ""}</div>
                    <div style={{ fontSize: 10, color: "#475569", fontFamily: F.m }}>{r.firmaDigital.timestamp}</div>
                    <div style={{ fontSize: 9, color: "#475569", fontFamily: F.m, marginTop: 2 }}>Hash: {r.hashIntegridad?.slice(0, 16)}...</div>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
